var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 52,
    height: 52,
    rx: 26,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40 37.5556C40 40.992 33.732 42 26 42C18.268 42 12 40.992 12 37.5556C12 34.1191 18.268 29.5556 26 29.5556C33.732 29.5556 40 34.1191 40 37.5556Z",
    stroke: "#8477AF",
    strokeWidth: 1.75
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33 17.1111C33 21.0385 29.866 24.2222 26 24.2222C22.134 24.2222 19 21.0385 19 17.1111C19 13.1838 22.134 10 26 10C29.866 10 33 13.1838 33 17.1111Z",
    stroke: "#8477AF",
    strokeWidth: 1.75
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.d1244f1c6c6180860436ba4c6fd4a19e.svg";
export { ForwardRef as ReactComponent };